<template>
  <div class="main editApplicationMain">
    <!-- 顶部 -->
    <div class="title">
      <img src="../assets/back.png" class="back" @click="goBack" />
      <span class="text">预览申请表</span>
    </div>

    <!-- 下部分 -->
    <div class="whiteBackground">
      <!-- 标题 -->
      <div class="headling">
        <span>上海市绿色建筑协会会员申请表</span>
      </div>
      <!-- 基本信息 -->
      <div class="part1">
        <img src="../assets/message.png" />
        <span class="caption">基本信息</span>
      </div>
      <div class="part2">
        <el-form :label-position="labelPosition" label-width="140px" size="small">
          <el-row :gutter="80">
            <el-col :span="11">
              <el-form-item label="单位名称（中文）:" required>
                <el-input v-model="this.infoData.companyname" clearable disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="单位名称（英文）:" required>
                <el-input v-model="this.infoData.companyname1" clearable disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="80">
            <el-col :span="11">
              <el-form-item label="联系地址:" required>
                <el-input v-model="this.infoData.address" clearable disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="邮编:" required>
                <el-input v-model="this.infoData.postcode" clearable disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="80">
            <el-col :span="11">
              <el-form-item label="公司网址:" required>
                <el-input v-model="this.infoData.website" clearable disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="推荐单位:" required>
                <el-input v-model="this.infoData.recommendcompany" clearable disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="11">
              <el-form-item label="所在行政区:">
                <el-select v-model="this.infoData.administrativeregion" filterable>
                  <el-option
                    v-for="(item, index) in options"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                    disabled
                  ></el-option>
                </el-select>
                <span style="color: #f00;font-size: 14px;">仅限联系地址为上海的单位选择</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="单位简介:" required>
            <el-input
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 6}"
              v-model="this.infoData.introduction"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="简介附件:" required>
            <el-button type="primary" size="medium">选择文件</el-button>
            <input
              type="file"
              disabled
              hidden
              ref="chooseFiles"
              accept=".doc, .docx"
            />
            <p>
              <span v-if="!fileUrl">{{this.infoData.fileid}}</span>
              <a v-if="fileUrl" :href="fileUrl" target="_blank">{{this.infoData.fileid}}</a>
            </p>
            <div
              style="font-size:14px;"
            >简介附件要求:&nbsp;&nbsp;(doc/docx文件)，文字1500字以上，配3张以上精度较高的图片</div>
            <div style="color: #f00;">文件大小不得超过50MB</div>
          </el-form-item>
        </el-form>
      </div>
      <!-- 企业类型 -->
      <div class="part">
        <div class="part1">
          <img src="../assets/enterprise.png" />
          <span class="caption">企业类型</span>
        </div>
        <div class="part2">
          <el-form>
            <el-form-item>
              <el-radio-group v-model="this.infoData.ownershipoption" disabled>
                <el-radio label="-24776">国企</el-radio>
                <el-radio label="-24777">私企</el-radio>
                <el-radio label="-24781">港外合资</el-radio>
                <el-radio label="-24778">外资独资</el-radio>
                <el-radio label="-24782">事业</el-radio>
                <el-radio label="-24779">合资</el-radio>
                <el-radio label="-24783">院校</el-radio>
                <el-radio label="-24780">政府</el-radio>
                <el-radio label="-24784">其他</el-radio>
                <el-input
                  disabled
                  v-model="this.infoData.ownershipother"
                  class="input-200"
                  size="small"
                ></el-input>
              </el-radio-group>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <!-- 企业规模 -->
      <div class="part">
        <div class="part1">
          <img src="../assets/calculate.png" />
          <span class="caption">企业规模</span>
        </div>
        <div class="part2">
          <el-form>
            <el-form-item>
              <el-radio-group v-model="this.infoData.scaleoption" disabled>
                <el-radio label="-24798">大型企业</el-radio>
                <el-radio label="-24799">中型企业</el-radio>
                <el-radio label="-24800">小型企业</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <!-- 是否上市公司 -->
      <div class="part">
        <div class="part1">
          <img src="../assets/public_company.png" />
          <span class="caption">是否上市</span>
        </div>
        <div class="part2">
          <el-form>
            <el-form-item>
              <el-radio-group v-model="this.infoData.public_company" disabled>
                <el-radio label="-25001">是上市企业</el-radio>
                <el-radio label="-25002">不是上市企业</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <!-- 主营业务 -->
      <div class="part">
        <div class="part1">
          <img src="../assets/business.png" />
          <span class="caption">主营业务</span>
        </div>
        <div class="part2">
          <el-form>
            <el-form-item>
              <el-checkbox-group v-model="this.infoData.businessnatureoption" disabled>
                <el-checkbox label="-24786">设计规划</el-checkbox>
                <el-checkbox label="-24792">建筑材料</el-checkbox>
                <el-checkbox label="-24787">咨询管理</el-checkbox>
                <el-checkbox label="-24793">设备/产品</el-checkbox>
                <el-checkbox label="-24788">开发商</el-checkbox>
                <el-checkbox label="-24794">运行/维护</el-checkbox>
                <el-checkbox label="-24789">总承包商</el-checkbox>
                <el-checkbox label="-24795">软件/平台</el-checkbox>
                <el-checkbox label="-24790">专业施工</el-checkbox>
                <el-checkbox label="-24791">科研院校</el-checkbox>
                <el-checkbox label="-24796">其他</el-checkbox>
                <el-input
                  disabled
                  v-model="this.infoData.businessnatureother"
                  class="input-200"
                  size="small"
                ></el-input>
              </el-checkbox-group>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <!-- 会员代表 -->
      <div class="part">
        <div class="part1">
          <img src="../assets/memeber.png" />
          <span class="caption">会员代表（会员代表建议为贵司主要领导或分管负责人）</span>
        </div>
        <div class="part2">
          <el-form :label-position="labelPosition" label-width="140px" size="small">
            <el-row :gutter="80">
              <el-col :span="11">
                <el-form-item label="姓名（中文）:" required>
                  <el-input v-model="this.infoData.representativename" clearable disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="11">
                <el-form-item label="姓名（英文）:" required>
                  <el-input v-model="this.infoData.representativename1" clearable disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="80">
              <el-col :span="11">
                <el-form-item label="性别:" required>
                  <el-input v-model="this.infoData.gender" clearable disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="11">
                <el-form-item label="职务:" required>
                  <el-input v-model="this.infoData.representativeposition" clearable disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="80">
              <el-col :span="11">
                <el-form-item label="电话:" required>
                  <el-input v-model="this.infoData.representativetel" clearable disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="11">
                <el-form-item label="手机:" required>
                  <el-input v-model="this.infoData.representativephone" clearable disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="80">
              <el-col :span="11">
                <el-form-item label="电邮:" required>
                  <el-input v-model="this.infoData.representativeemail" clearable disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="11">
                <el-form-item label="传真:" required>
                  <el-input v-model="this.infoData.representativetax" clearable disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="80">
              <el-col :span="11">
                <el-form-item label="身份证号:" required>
                  <el-input v-model="this.infoData.idcard" clearable disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="11">
                <el-form-item label="政治面貌:" required>
                  <el-input v-model="this.infoData.politicsstatus" clearable disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="11">
                <el-form-item label="是否离退:" required>
                  <el-radio-group v-model="this.infoData.ismembership" disabled>
                    <el-radio label="是"></el-radio>
                    <el-radio label="否"></el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
      <!-- 联系人 -->
      <div class="part">
        <div class="part1">
          <img src="../assets/linkman.png" />
          <span class="caption">联系人（联系人为贵司与协会日常沟通人员）</span>
        </div>
        <div class="part2">
          <el-form :label-position="labelPosition" label-width="140px" size="small">
            <el-row :gutter="80">
              <el-col :span="11">
                <el-form-item label="姓名（中文）:" required>
                  <el-input v-model="this.infoData.contactpersoncontactname" clearable disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="11">
                <el-form-item label="姓名（英文）:" required>
                  <el-input v-model="this.infoData.contactpersoncontactname1" clearable disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="80">
              <el-col :span="11">
                <el-form-item label="职务:" required>
                  <el-input v-model="this.infoData.contactpersonposition" clearable disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="11">
                <el-form-item label="电邮:" required>
                  <el-input v-model="this.infoData.contactpersonemail" clearable disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="80">
              <el-col :span="11">
                <el-form-item label="手机:" required>
                  <el-input v-model="this.infoData.contactpersonphone" clearable disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="11">
                <el-form-item label="电话:" required>
                  <el-input v-model="this.infoData.contactpersontel" clearable disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="80">
              <el-col :span="11">
                <el-form-item label="传真:" required>
                  <el-input v-model="this.infoData.contactpersonfax" clearable disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="11">
                <el-form-item label="联系地址:" required>
                  <el-input v-model="this.infoData.contactpersonaddress" clearable disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="80">
              <el-col :span="11">
                <el-form-item label="邮编:" required>
                  <el-input v-model="this.infoData.contactpersonpostcode" clearable disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
      <!-- 党建工作 -->
      <div class="part">
        <div class="part1">
          <img src="../assets/poverty.png" />
          <span class="caption">党建工作</span>
        </div>
        <div class="part2">
          <el-form :label-position="labelPosition" label-width="140px" size="small">
            <el-row style="margin-left: -140px;">
              <el-form-item>
                <el-radio-group v-model="this.infoData.partyoption" disabled>
                  <el-radio label="-24802">党委</el-radio>
                  <el-radio label="-24803">党支部</el-radio>
                  <el-radio label="-24804">无</el-radio>
                  <!-- <el-input
                    disabled
                    v-model="this.infoData.partyremark"
                    class="input-200"
                    size="small"
                  ></el-input> -->
                </el-radio-group>
              </el-form-item>
            </el-row>
            <el-row :gutter="80">
              <el-col :span="11">
                <el-form-item label="成立时间:" required>
                  <el-date-picker
                    v-model="this.infoData.partyestablishtime"
                    type="date"
                    size="small"
                    clearable
                    disabled
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="11">
                <el-form-item label="党员人数:" required>
                  <el-input
                    v-model="this.infoData.partymembernumber"
                    clearable
                    size="small"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="80">
              <el-col :span="11">
                <el-form-item label="党建联系人:" required>
                  <el-input v-model="this.infoData.partylinkman" clearable disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="11">
                <el-form-item label="职务:" required>
                  <el-input v-model="this.infoData.partyposition" clearable disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="80">
              <el-col :span="11">
                <el-form-item label="手机:" required>
                  <el-input v-model="this.infoData.partyphone" clearable disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="11">
                <el-form-item label="电话:" required>
                  <el-input v-model="this.infoData.partytel" clearable disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="80">
              <el-col :span="11">
                <el-form-item label="邮箱:" required>
                  <el-input v-model="this.infoData.partyemail" clearable disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="其他情况说明:">
              <el-input
                type="textarea"
                :autosize="{ minRows: 4, maxRows: 6}"
                v-model="this.infoData.partyother"
                disabled
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <!-- 声明 -->
      <div class="part">
        <div class="part1">
          <img src="../assets/statement.png" />
          <span class="caption">声明</span>
        </div>
        <div class="part2">
          <el-form>
            <div class="promiss">
              <p class="promiss-text">本单位自愿加入上海市绿色建筑协会，遵守协会章程，并积极参与协会各项活动。</p>
            </div>
            <div class="box">
              <div class="box-item">
                <div class="text">单位盖章:</div>
                <input disabled class="smallInput" style="visibility: hidden;" />
              </div>
              <div class="box-item">
                <div class="text">法人代表:</div>
                <input disabled class="smallInput" />
              </div>
              <div class="box-item">
                <div class="text">日期:</div>
                <input disabled class="smallInput" />
              </div>
            </div>
            <el-row>
              <el-col :span="24">
                <el-form-item label="审核意见:" required style="margin-left:100px;">
                  <el-input type="textarea" :disabled="true" :autosize="{ minRows: 4, maxRows: 6}"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <div class="box">
              <div class="box-item">
                <div class="text">签字:</div>
                <input disabled class="smallInput" />
              </div>
              <div class="box-item">
                <div class="text">日期:</div>
                <input disabled class="smallInput" />
              </div>
            </div>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as Cache from '../utils/cache'
import * as API from '../utils/apiService'

export default {
  data () {
    return {
      id: '', // 表格选中的用户id
      fileUrl: '',
      labelPosition: 'right', // label对齐方式
      // 基本信息
      infoData: {
        companyname: '', // 单位名称（中文）
        companyname1: '', // 单位名称（英文）
        address: '', // 联系地址
        administrativeregion: '', // 所在行政区
        website: '', // 公司网址
        postcode: '', // 邮编
        recommendcompany: '', // 推荐单位
        introduction: '', // 单位简介
        fileid: '', // 单位简介附件
        // 企业类型
        ownershipoption: '', // 企业类型
        ownershipother: '', // 企业类型备注
        // 企业规模
        scaleoption: '', // 企业规模
        // 上市公司
        public_company: '', // 上市公司
        // 主营业务
        businessnatureoption: [], // 主营业务
        businessnatureother: '', // 主营业务备注
        // 会员代表
        representativename: '', // 姓名（中文）
        representativename1: '', // 姓名（英文）
        gender: '', // 性别
        representativeposition: '', // 职务
        representativetel: '', // 电话
        representativephone: '', // 手机
        representativeemail: '', // 电邮
        representativetax: '', // 传真
        idcard: '', // 身份证号
        politicsstatus: '', // 政治面貌
        ismembership: '', // 是否离退
        // 联系人
        contactpersoncontactname: '', // 姓名(中文)
        contactpersoncontactname1: '', // 姓名(英文)
        contactpersonposition: '', // 职务
        contactpersonemail: '', // 电邮
        contactpersonphone: '', // 手机
        contactpersontel: '', // 电话
        contactpersonfax: '', // 传真
        contactpersonaddress: '', // 联系地址
        contactpersonpostcode: '', // 邮编
        // 党建工作
        partyoption: '', // 党建工作
        // partyremark: '', // 党建工作备注
        partyestablishtime: '', // 成立时间
        partymembernumber: '', // 党员人数
        partylinkman: '', // 党建联系人
        partyposition: '', // 党建职务
        partyphone: '', // 党建手机
        partytel: '', // 党建电话
        partyemail: '', // 党建邮箱
        partyother: '' // 党建其他情况说明
      },
      options: [
        {
          value: '',
          label: '请选择'
        },
        {
          value: 'HP',
          label: '黄浦区'
        },
        {
          value: 'XH',
          label: '徐汇区'
        },
        {
          value: 'CN',
          label: '长宁区'
        },
        {
          value: 'JA',
          label: '静安区'
        },
        {
          value: 'PT',
          label: '普陀区'
        },
        {
          value: 'HK',
          label: '虹口区'
        },
        {
          value: 'YP',
          label: '杨浦区'
        },
        {
          value: 'MH',
          label: '闵行区'
        },
        {
          value: 'BS',
          label: '宝山区'
        },
        {
          value: 'JD',
          label: '嘉定区'
        },
        {
          value: 'PD',
          label: '浦东新区'
        },
        {
          value: 'JS',
          label: '金山区'
        },
        {
          value: 'SJ',
          label: '松江区'
        },
        {
          value: 'QP',
          label: '青浦区'
        },
        {
          value: 'FX',
          label: '奉贤区'
        }
      ]
    }
  },
  mounted () {
    this.asyncFindOneInfo()
  },
  methods: {
    goBack () {
      this.$router.go(-1)
    },
    asyncFindOneInfo () {
      let params = {
        userid: Cache.getUserInfo().id
      }
      API.findOneInfo(params).then(resp => {
        if (resp.resultCode === '0000') {
          const businessnatureoption = resp.data.businessnatureoption
          if (businessnatureoption === 'false') {
            resp.data.businessnatureoption = []
          } else {
            resp.data.businessnatureoption = businessnatureoption.split(',')
          }
          this.infoData = resp.data
          this.fileUrl = resp.data.file
          let newFileUrl = this.fileUrl.split('/')
          this.fileNAME = newFileUrl[newFileUrl.length - 1]
        }
      })
    }
  }
}
</script>

<style lang="scss">
.editApplicationMain {
  .title {
    display: flex;
    align-items: center;
    .back {
      width: 30px;
      margin-left: 15px;
      cursor: pointer;
    }
  }
  .whiteBackground {
    width: calc(100% - 10px);
    background: #fff;
    .headling {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 20px 0 0 0;
      height: 80px;
      span {
        font-size: 22px;
        font-weight: 550;
        color: #444;
      }
    }
    .el-input {
      width: 100%;
    }
    .el-textarea {
      width: 70%;
    }
    .el-select {
      width: 100%;
      padding-right: 40px;
    }
    .el-input__inner {
      font-size: 16px !important;
    }
    .part {
      margin-top: 30px;
    }
    .btns {
      display: flex;
      justify-content: center;
      align-items: center;
      padding-bottom: 30px;
    }
    .part1 {
      display: flex;
      align-items: center;
      width: 96%;
      margin-left: 2%;
      height: 40px;
      border-bottom: 1px solid #e3e3e3;
      img {
        width: 24px;
      }
      .caption {
        margin-left: 10px;
        font-size: 18px;
        font-weight: 550;
        color: #555;
      }
    }
    .part2 {
      width: 90%;
      margin-left: 5%;
      margin-right: 5%;
      padding-bottom: 40px;
      line-height: 23px;
      margin-top: 40px;
      color: rgba(102, 102, 102, 1);
      input {
        font-size: 18px;
      }
      .input-200 {
        width: 200px;
      }
      .promiss {
        height: 90px;
        display: flex;
        justify-content: center;
        align-items: center;
        .promiss-text {
          border-bottom: 1px solid #e3e3e3;
          height: 90px;
        }
      }
      .box {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        margin-top: 30px;
        margin-bottom: 30px;
        .box-item {
          height: 35px;
          line-height: 35px;
          .text {
            width: 70px;
            white-space: nowrap;
            text-align: right;
            color: #666;
            font-size: 16px;
            font-weight: normal;
            float: left;
          }
          .line {
            float: right;
            width: 70%;
            border-bottom: 1px solid #e3e3e3;
          }
        }
      }
    }
  }
  .smallInput {
    width: 200px !important;
    border: 0;
    border-bottom: 1px solid #ccc;
    outline: none;
  }
}
</style>
